// app-init.service.ts
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { StorageService } from './storage.service';

@Injectable()
export class AppInitService {
  constructor(
    private authService: AuthService,
    private storageService: StorageService
  ) {}

  async init(): Promise<void> {
    const urlParams = new URLSearchParams(window.location.search);

    const tokens = {
      access_token: urlParams.get('access_token'),
      expires_in: urlParams.get('expires_in'),
      id_token: urlParams.get('id_token'),
      scope: urlParams.get('scope'),
      token_type: urlParams.get('token_type'),
    };

    if (tokens.access_token) {
      await this.authService.processarBrasilCidadao(tokens);
      this.storageService.setFlagTokensProcessados(true);
      window.history.replaceState({}, '', window.location.pathname);
    }

    await this.authService.loginScab();
    await this.authService.loginBarramento();
    console.log('INIT token bc: ', this.storageService.getTokenBc());
    console.log('INIT token scba: ', this.storageService.getTokenScab());
    console.log('INIT token barramento: ', this.storageService.getTokenBarramento());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/app-init.service.ts